export default __webpack_public_path__ + "static/media/13.bad0eff1.png";